import { toJalaali } from 'jalaali-js';

export const JalaliDate=(epoch)=>{
    const date = new Date(epoch * 1000); // Convert epoch time to milliseconds
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth() + 1;
    const day = date.getUTCDate();
  
    const jalaliDate = toJalaali(year, month, day);
  
    return `${jalaliDate.jy}/${jalaliDate.jm}/${jalaliDate.jd}`
}